<div class="modal-content">
    <div class="modal-header">
        <h3 class="modal-title">{{ ((idNewRow)? 'Crear Nueva ': 'Editar ') + 'Tarea' }}</h3>
        <button class="btn-close" type="button" (click)="activeModal.close()"></button>
    </div>

    <div class="modal-body">
        <form [formGroup]="taskForm">
            <!-- Sección: Detalles -->
            <h5 class="mt-3 mb-2">Detalles de la tarea</h5>
            <div class="row g-2">
                <div class="col-md-12">
                    <label>Tarea<span class="txt-danger"> *</span></label>
                    <input class="form-control" name="title" type="text"
                           [class.is-invalid]="taskForm.get('title')?.touched && taskForm.get('title')?.invalid"
                           formControlName="title" id="title">
                    <div *ngIf="taskForm.get('title')?.touched && taskForm.get('title')?.invalid" class="invalid-feedback">
                        Ingrese un valor válido.
                    </div>
                </div>
                <div class="col-md-12">
                    <label>Comentarios</label>
                    <textarea class="form-control" name="comments" rows="3" formControlName="description" id="description"></textarea>
                </div>
                <div class="col-md-12 mb-3">
                    <div class="mb-3">
                        <label>Evidencias</label>
                        <form class="dropzone dropzone-light custom-scrollbar customize-dropzone">
                            <dropzone [config]="config" [message]="textDropzone" (init)="onDropzoneInit($event)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)" (removedFile)="onRemoveSuccess($event)">
                            </dropzone>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Sección: Responsables -->
            <h5 class="mt-4 mb-2">Responsables</h5>
            <div class="row g-2">
                <div class="col-md-6">
                    <label>Área Responsable<span class="txt-danger"> *</span></label>
                    <select class="form-control" name="area"
                            [class.is-invalid]="taskForm.get('responsible_area')?.touched && taskForm.get('responsible_area')?.invalid"
                            formControlName="responsible_area" id="responsible_area">
                        <option *ngFor="let area of areaOptions" [value]="area.id">{{ area.value }}</option>
                    </select>
                    <div *ngIf="taskForm.get('responsible_area')?.touched && taskForm.get('responsible_area')?.invalid" class="invalid-feedback">
                        Seleccione un área.
                    </div>
                </div>
                <div class="col-md-6">
                    <label>Usuario Responsable<span class="txt-danger"> *</span></label>
                    <select class="form-control" name="responsibleUser"
                            [class.is-invalid]="taskForm.get('assigned_user_id')?.touched && taskForm.get('assigned_user_id')?.invalid"
                            formControlName="assigned_user_id" id="assigned_user_id">
                        <option *ngFor="let user of userOptions" [value]="user.l">{{ user.name }}</option>
                    </select>
                    <div *ngIf="taskForm.get('assigned_user_id')?.touched && taskForm.get('assigned_user_id')?.invalid" class="invalid-feedback">
                        Seleccione un responsable.
                    </div>
                </div>
            </div>

            <!-- Sección: Fechas -->
            <h5 class="mt-4 mb-2">Fechas y Estado</h5>
            <div class="row g-2">
                <div class="col-md-6">
                    <label>Fecha límite<span class="txt-danger"> *</span></label>
                    <input class="form-control" type="datetime-local"
                           [class.is-invalid]="taskForm.get('due_date')?.touched && taskForm.get('due_date')?.invalid"
                           formControlName="due_date" id="due_date">
                    <div *ngIf="taskForm.get('due_date')?.touched && taskForm.get('due_date')?.invalid" class="invalid-feedback">
                        Ingrese un valor válido.
                    </div>
                </div>
                <div class="col-md-6">
                    <label>Estado<span class="txt-danger"> *</span></label>
                    <select class="form-control" [class.is-invalid]="taskForm.get('status')?.touched && taskForm.get('status')?.invalid"
                            formControlName="status" id="status">
                        <option value="Abierto">Abierto</option>
                        <option value="En proceso">En proceso</option>
                        <option value="Finalizado">Finalizado</option>
                    </select>
                    <div *ngIf="taskForm.get('status')?.touched && taskForm.get('status')?.invalid" class="invalid-feedback">
                        Seleccione un estado.
                    </div>
                </div>
                <div class="col-md-12" *ngIf="taskForm.get('status')?.value === 'Finalizado'">
                    <label>Comentarios de cierre</label>
                    <input class="form-control"
                           name="closing_comments"
                           type="text"
                           formControlName="closing_comments"
                           id="closing_comments">
                </div>

<!--                <div class="col-md-6">-->
<!--                    <label>Fecha en proceso</label>-->
<!--                    <input class="form-control" [value]="task.inProcessAt | date:'short'" disabled>-->
<!--                </div>-->
<!--                <div class="col-md-6">-->
<!--                    <label>Usuario en proceso</label>-->
<!--                    <input class="form-control" [value]="task.inProcessBy" disabled>-->
<!--                </div>-->

<!--                <div class="col-md-6">-->
<!--                    <label>Fecha finalizado</label>-->
<!--                    <input class="form-control" [value]="task.finishedAt | date:'short'" disabled>-->
<!--                </div>-->
<!--                <div class="col-md-6">-->
<!--                    <label>Usuario finalizó</label>-->
<!--                    <input class="form-control" [value]="task.finishedBy" disabled>-->
<!--                </div>-->
            </div>

            <!-- Botones -->
            <div class="modal-footer mt-4">
                <button class="btn btn-secondary col-auto" type="button" (click)="activeModal.close()">Cancelar</button>
                <button class="btn btn-primary col-auto" type="button" (click)="submitForm()">Guardar</button>
            </div>
        </form>
    </div>
</div>
